<div class="flex-jb" style="margin-bottom:14px;gap:12px;flex-wrap:wrap">
  <span class="ao-search">
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
    <input
      class="ao-search-input"
      type="text"
      [attr.aria-label]="'site.prevention.offer.addOfferPage.searchAriaLabel' | translate"
      [placeholder]="'site.prevention.offer.addOfferPage.searchPlaceholder' | translate"
      [value]="search()"
      (input)="onSearchChanged($any($event.target).value)">
  </span>
  <button class="ao-create-btn" (click)="createOffer.emit()">
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
    {{ 'site.prevention.offer.addOfferPage.createNewOfferCta' | translate }}
  </button>
</div>

@if (isGloballyEmpty()) {
  <div class="card"><div class="cs" style="text-align:center;padding:20px 0">{{ 'site.prevention.offer.addOfferPage.emptyGroupCatalog' | translate }}</div></div>
} @else if (hasSearchNoResults()) {
  <div class="card"><div class="cs" style="text-align:center;padding:20px 0">{{ 'site.prevention.offer.addOfferPage.emptySearch' | translate }}</div></div>
} @else {
  <div class="card">
    @for (offer of filteredOffers(); track offer.offerId) {
      <div class="ao-offer">
        <div class="ao-offer-content">
          @if (photoUrl(offer); as thumb) {
            <img class="ao-offer-thumb" [src]="thumb" alt="">
          }
          <div class="ao-offer-main">
            <div class="ao-offer-name">{{ offer.name }}</div>
            <div class="cs">{{ bilanNames(offer) }}</div>
          </div>
        </div>
        <div style="display:flex;align-items:center;gap:8px;flex-shrink:0">
          <button class="btn-secondary-sm" (click)="viewDetails.emit(offer.offerId)">{{ 'site.prevention.offer.addOfferPage.detailsButton' | translate }}</button>
          @if (offer.activeForEstablishment) {
            <span class="ao-added-badge">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>
              {{ 'site.prevention.offer.addOfferPage.alreadyActiveBadge' | translate }}
            </span>
          } @else {
            <button class="btn-green-sm" (click)="activateOffer.emit(offer.offerId)">{{ 'site.prevention.offer.addOfferPage.addButton' | translate }}</button>
          }
        </div>
      </div>
    }
  </div>
}
